var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.917,
    height: 28.435,
    viewBox: "0 0 14.917 28.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-mobile",
    transform: "translate(-34 -19.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(34 19.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M46.819,19.5H36.1A2.089,2.089,0,0,0,34,21.6v24.24a2.089,2.089,0,0,0,2.1,2.1H46.819a2.089,2.089,0,0,0,2.1-2.1V21.6A2.089,2.089,0,0,0,46.819,19.5Zm1.632,26.337a1.652,1.652,0,0,1-1.632,1.632H36.1a1.621,1.621,0,0,1-1.632-1.632V21.6A1.652,1.652,0,0,1,36.1,19.966H46.819A1.652,1.652,0,0,1,48.451,21.6Z",
    transform: "translate(-34 -19.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M36.3,48.544H49.072V28.5H36.3Zm.466-19.578h11.84V48.078H36.766Z",
    transform: "translate(-35.228 -24.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M47.58,25.466h2a.22.22,0,0,0,.233-.233.261.261,0,0,0-.28-.233h-2a.22.22,0,0,0-.233.233A.261.261,0,0,0,47.58,25.466Z",
    transform: "translate(-41.1 -22.436)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 0.233,
    cy: 0.233,
    r: 0.233,
    transform: "translate(7.225 1.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M48.238,72.2a1.538,1.538,0,1,0,1.538,1.538A1.552,1.552,0,0,0,48.238,72.2Zm0,2.61a1.072,1.072,0,1,1,1.072-1.072A1.055,1.055,0,0,1,48.238,74.81Z",
    transform: "translate(-40.78 -47.634)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobileIcon.4ed03ac9a55b99e34edb8708d9966225.svg";
export { ForwardRef as ReactComponent };